import React from "react";
import { Dialog } from "Components";

type ConfirmSaveProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmSave = ({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmSaveProps): React.JSX.Element => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm changes to SSO configuration"
      confirmText="Confirm"
      onConfirm={onConfirm}
      onCancel={onClose}
    >
      <p>Changing these settings can lock your users out of Spectra Assure.</p>
      <p>
        To make sure that doesn&rsquo;t happen, we have to verify your changes.
      </p>
      <p>
        When you click &quot;Confirm&quot;, you&rsquo;ll be redirected to your
        identity provider to re-authenticate. When you arrive back here, we can
        verify your changes are valid and apply them.
      </p>
      <p>
        If your changes can&rsquo;t be applied, they will be rolled back
        automatically.
      </p>
    </Dialog>
  );
};

export default ConfirmSave;
